import Joi from '@hapi/joi'

export const companyListSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select Group`,
        "any.required": `Group required`
    }),
}

export const companySchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select Group`,
        "any.required": `Group required`
    }),

    operationEntityCode: Joi.string().required().min(2).max(2).label("Company Code").regex(/^\w+(?:\s+\w+)*$/).messages({
        "string.empty": `Company required`,
        "string.pattern.base": `Company code cannot have invalid characters`,
        "string.min": `Please enter {#limit} digit number`,
        "string.max": `Please enter {#limit} digit number`
    }),
    operationEntityName:Joi.string().required().label("Company Name").regex(/^(?!\s*$).+/).messages({
        "string.empty": `Company name Name required`,
        "string.pattern.base": `Please enter valid company name`,
    }),
    operationEntityLocation:Joi.string().required().label("Location").regex(/^(?!\s*$).+/).messages({
        "string.empty": `Company Location required`,
        "string.pattern.base": `Please enter valid companylocation`,
    }),

    enityTypeID: Joi.number().invalid(0).required().label("Entity Type").messages({
        "any.invalid": `Select Entity type`,
        "any.required": `Entity type required`
    }),

    isErpEnabled: Joi.boolean().label("Active"),
   
    isActive: Joi.boolean().label("Active")
}
    






